// CR 編輯輪播

import { TEAM_INFO } from "../common/constant";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import '../../../styles/swipers.scss'; // 輪播樣式
import CRTeamItem from "./CRTeamItem";

const CRTeamSwiperWrap = () =>{

    const repeatedArray = [].concat(TEAM_INFO, TEAM_INFO, TEAM_INFO);
    
    return(
        <>
            {/* pc版顯示 */}
            <Swiper
                id="team-swiper"
                className="content-wrap w-full overflow-hidden team-content-wrap flex asm:[&>.swiper-wrapper]:flex usm:!hidden"
                modules={[Autoplay, Navigation]}
                centeredSlides={true} // 居中顯示當前 slide
                slidesPerView={1}
                spaceBetween={10}
                loop={true}
                navigation={true}
                direction={'horizontal'} // 水平方向
                freeMode={true}
                autoplay={{
                    delay: 3000,
                }}
                breakpoints={{
                    // when window width is >= 280,
                    260: {
                        slidesPerView: 1.3,
                    },
                    355: {
                        slidesPerView: 1.7,
                    },
                    470: {
                        slidesPerView: 2.1,
                    },
                    560: {
                        slidesPerView: 2.5,
                    },
                    750: {
                        slidesPerView: 3.5,
                    },
                    1024: {
                        slidesPerView: 4.5,
                    },
                    1200: {
                        slidesPerView: 5.15,
                    },
                }}
            >
                {Object.values(repeatedArray).map((item,i)=>
                    <SwiperSlide
                        key={`team-item-${i}`}
                        className="team-item w-full h-[300px] bg-yellow text-jblack flex-shrink-0 usm:h-full pr-[20px] usm:px-[5px]"
                    >
                        <CRTeamItem key={`team_${i}`} info={item}/>

                    </SwiperSlide>
                )}
            </Swiper>


            {/* mobile版顯示 */}
            <div className="content-wrap w-full overflow-hidden team-content-wrap 
                flex-wrap center-center gap-x-[10px] !hidden usm:!flex">
                {Object.values(TEAM_INFO).map((item,i)=>
                    <CRTeamItem key={`team_${i}`} info={item} isMobile={true}/>
                )}
            </div>

        </>
    )
}

export default CRTeamSwiperWrap;